import { render, staticRenderFns } from "./LayoutFolderBrowserModal.vue?vue&type=template&id=5b5a0830&scoped=true"
import script from "./LayoutFolderBrowserModal.vue?vue&type=script&lang=js"
export * from "./LayoutFolderBrowserModal.vue?vue&type=script&lang=js"
import style0 from "./LayoutFolderBrowserModal.vue?vue&type=style&index=0&id=5b5a0830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a0830",
  null
  
)

export default component.exports